import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom/dist";
import Table from "../../../../core/pagination/datatable";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import { Edit, RotateCcw } from "feather-icons-react/build/IconComponents";
import EditManualAttendance from "./Edit";
import {
  ROLL_CALL_API_BASE_URL,
  ROLL_CALL_EMPLOYEES_LIST,
} from "../RollCallConfig/RollCallConfig";
import { Select, Spin } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

const RollcallManualAttendanceList = () => {
  const today = new Date().toISOString().split("T")[0];
  const [employees, setEmployees] = useState([]);
  const [editObj, setEditObj] = useState([]);
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [selectedstartDate, setSelectedstartDate] = useState(today);
  const [selectedendDate, setSelectedendDate] = useState(today);
  const [teamAttendance, setTeamAttendance] = useState([]);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [perm, setPerm] = useState({
    Read: false,
    Write: false,
    Delete: false,
    Export: false,
  });

  const [showEdit, setShowEdit] = useState(false);

  useEffect(() => {
    const stored = sessionStorage.getItem("rollcall-permissions");
    if (!stored) return;

    const map = JSON.parse(stored);
    const path = location.pathname.slice(1);
    const perms = map[path];
    if (!perms) {
      navigate("/rollcall/dashboard");
      return;
    }
    if (perms) {
      setPerm({
        Read: perms.canRead,
        Write: perms.canWrite,
        Delete: perms.canDelete,
        Export: perms.canExport,
      });
    }
  }, []);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      fetch(
        `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_EMPLOYEES_LIST}?superid=${superIdData}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${tokenData}` },
        },
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          if (data && data.status) {
            setEmployees(data.ResultData || []);
          } else {
            console.error("Invalid data format:", data);
            setEmployees([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [superIdData, tokenData]);

  const empOptions = employees?.map((emp) => ({
    value: emp.RegId,
    label: emp.UserName,
  }));

  // useEffect(() => {
  //   const handleSubmit = async () => {
  //     setloading(true);
  //     if (tokenData && superIdData) {
  //       try {
  //         const params = new URLSearchParams();
  //         params.append("Superid", superIdData);
  //         if (selectedstartDate) params.append("startdate", selectedstartDate);
  //         if (selectedendDate) params.append("enddate", selectedendDate);
  //         if (selectedEmp) params.append("regid", selectedEmp);

  //         const response = await fetch(
  //           `${ROLL_CALL_API_BASE_URL}portal/Attendance/getattendanceForAdmin?${params.toString()}`,
  //           {
  //             method: "GET",
  //             headers: {
  //               "Content-Type": "application/json",
  //               Authorization: `Bearer ${tokenData}`,
  //             },
  //           }
  //         );

  //         if (response.ok) {
  //           const data = await response.json();
  //           if (data.status) {
  //             console.log("team att:", data);
  //             setTeamAttendance(data["ResultData"]);
  //           } else {
  //             setTeamAttendance([]);
  //           }
  //         } else {
  //           throw new Error("Failed to fetch data");
  //         }
  //       } catch (error) {
  //         console.error("Error:", error);
  //       } finally {
  //         setloading(false);
  //       }
  //     }
  //   };
  //   handleSubmit();
  // }, [superIdData, tokenData]);

  const fetchTeamAttendance = async () => {
    setloading(true);

    if (!tokenData || !superIdData) {
      setloading(false);
      return;
    }

    try {
      const params = new URLSearchParams();
      params.append("Superid", superIdData);
      if (selectedstartDate) params.append("startdate", selectedstartDate);
      if (selectedendDate) params.append("enddate", selectedendDate);
      if (selectedEmp) params.append("regid", selectedEmp);

      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/Attendance/getattendanceForAdmin?${params.toString()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenData}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const data = await response.json();

      if (data.status) {
        setTeamAttendance(data.ResultData);
      } else {
        setTeamAttendance([]);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    fetchTeamAttendance();
  }, [tokenData, superIdData]);

  const handleSubmit = async () => {
    setloading(true);
    if (tokenData && superIdData) {
      try {
        const params = new URLSearchParams();
        params.append("Superid", superIdData);
        if (selectedstartDate) params.append("startdate", selectedstartDate);
        if (selectedendDate) params.append("enddate", selectedendDate);
        if (selectedEmp) params.append("regid", selectedEmp);

        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/Attendance/getattendanceForAdmin?${params.toString()}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
          },
        );

        if (response.ok) {
          const data = await response.json();
          if (data.status) {
            setTeamAttendance(data["ResultData"]);
          } else {
            setTeamAttendance([]);
          }
        } else {
          throw new Error("Failed to fetch data");
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setloading(false);
      }
    }
  };

  const filteredData = teamAttendance.filter(
    (item) => item && item.UserName && item.UserName.toLowerCase(),
  );

  const columns = [
    {
      title: "Name",
      dataIndex: "UserName",
      sorter: (a, b) => a.UserName?.localeCompare(b.UserName),
      render: (text) => (
        <span>{text?.length > 15 ? `${text.substring(0, 15)}...` : text}</span>
      ),
    },
    // {
    //   title: "Actual Shift",
    //   dataIndex: "ActualShiftName",
    //   sorter: (a, b) => {
    //     const nameA = a.ActualShiftName || "";
    //     const nameB = b.ActualShiftName || "";
    //     return nameA?.localeCompare(nameB);
    //   },
    // },

    {
      title: "Entry Time",
      dataIndex: "FormatInTime",
      sorter: (a, b) =>
        (a.FormatInTime || "").localeCompare(b.FormatInTime || ""),
      render: (text) => text || "N/A",
    },
    {
      title: "Exit Time",
      dataIndex: "FormatOutTime",
      sorter: (a, b) =>
        (a.FormatOutTime || "").localeCompare(b.FormatOutTime || ""),
      render: (text) => text || "N/A",
    },

    {
      title: "Entry Status",
      dataIndex: "InStatus",
      sorter: (a, b) => a.InStatus?.localeCompare(b.InStatus),
    },
    {
      title: "Exit Status",
      dataIndex: "OutStatus",
      sorter: (a, b) => a.OutStatus?.localeCompare(b.OutStatus),
    },
  ];

  if (perm?.Write) {
    columns.push({
      title: "Action",
      dataIndex: "exitStatus",
      render: (_, record) => (
        <Link
          to=""
          className="dropdown-item"
          title="Edit"
          onClick={() => handelShowEdit(record)}
        >
          <Edit className="info-img text-info" />
        </Link>
      ),
    });
  }

  const handelShowEdit = (record) => {
    setShowEdit(true);
    setEditObj(record);
  };

  const handleReload = () => {
    window.location.reload();
  };

  const handleDownloadExcel = () => {
    if (teamAttendance && teamAttendance?.length === 0) {
      return;
    }

    const wb = XLSX.utils.book_new();
    const wsData = teamAttendance?.map((item, index) => ({
      "S.No": index + 1,
      Name: item.UserName || "N/A",
      "Entry Time": item.FormatInTime || "N/A",
      "Exit Time": item.FormatOutTime || "N/A",
      "Entry Status": item.InStatus || "N/A",
      "Exit Status": item.OutStatus || "N/A",
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Employee Data");
    XLSX.writeFile(wb, "Manual Attendance.xlsx");
  };

  const generatePDF = () => {
    if (teamAttendance && teamAttendance?.length === 0) {
      return;
    }

    const doc = new jsPDF("p", "mm", "a4");
    doc.text("Employee Data Report", 14, 10);

    const tableColumn = [
      "S.No",
      "Name",
      "Entry Time",
      "Exit Time",
      "Entry Status",
      "Exit Status",
    ];

    const tableRows = teamAttendance?.map((item, index) => [
      index + 1,
      item.UserName || "N/A",
      item.FormatInTime || "N/A",
      item.FormatOutTime || "N/A",
      item.InStatus || "N/A",
      item.OutStatus || "N/A",
    ]);

    doc.autoTable({ head: [tableColumn], body: tableRows });
    doc.save("Manual Attendance.pdf");
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Manual Attendance
                    </h4>
                  </ol>
                </nav>
                <h6>Manage your employees attendance</h6>
              </div>
            </div>
            <ul className="table-top-head">
              {perm?.Export && (
                <>
                  <li>
                    <OverlayTrigger placement="top" overlay={renderTooltip}>
                      <Link onClick={generatePDF}>
                        <ImageWithBasePath
                          src="assets/img/icons/pdf.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>
                  <li>
                    <OverlayTrigger
                      placement="top"
                      overlay={renderExcelTooltip}
                    >
                      <Link
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        onClick={handleDownloadExcel}
                      >
                        <ImageWithBasePath
                          src="assets/img/icons/excel.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>
                </>
              )}

              <li onClick={handleReload}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>
          {/* /product list */}
          {perm.Read ? (
            <div className="card table-list-card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <div className="search-set"></div>
                <div className="d-flex justify-content-end align-items-end row">
                  <div className="col-4">
                    {/* <label className="form-label">Employee</label> */}
                    <Select
                      showSearch
                      placeholder="Choose Employee"
                      value={selectedEmp}
                      onChange={setSelectedEmp}
                      allowClear
                      options={empOptions}
                      style={{ width: 190, height: 37 }}
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </div>
                  <div className="col-3">
                    {/* <label className="form-label"> <span className="text-danger ms-1">*</span>Start Date</label> */}
                    <input
                      type="date"
                      className="form-control"
                      placeholder="Start Date"
                      value={selectedstartDate}
                      onChange={(e) => setSelectedstartDate(e.target.value)}
                    />
                  </div>
                  <div className="col-3">
                    {/* <label className="form-label"> <span className="text-danger ms-1">*</span>End Date</label> */}
                    <input
                      type="date"
                      className="form-control"
                      placeholder="End date"
                      value={selectedendDate}
                      onChange={(e) => setSelectedendDate(e.target.value)}
                    />
                  </div>
                  {/* <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Department
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Sales
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        IT
                      </Link>
                    </li>
                  </ul>
                </div> */}

                  <div className="col-2 ">
                    <button className="btn btn-primary" onClick={handleSubmit}>
                      <FontAwesomeIcon icon={faMagnifyingGlass} />
                    </button>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive brand-table">
                  {loading ? (
                    <div className="text-center my-4">
                      <Spin size="large" />
                      <p>Loading data...</p>
                    </div>
                  ) : filteredData?.length > 0 ? (
                    <Table
                      columns={columns}
                      dataSource={filteredData}
                      pgno={true}
                    />
                  ) : (
                    <p className="text-center my-4">No data available</p>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="card">
              <div className="card-body d-flex justify-content-center">
                <h1>You dont have access to this page</h1>
              </div>
            </div>
          )}
          {/* /product list */}
        </div>
        <CommonFooter />
        <EditManualAttendance
          isOpen={showEdit}
          editObj={editObj}
          fetchTeamAttendance={fetchTeamAttendance}
          onClose={() => setShowEdit(false)}
        />
      </div>
    </div>
  );
};

export default RollcallManualAttendanceList;
